<template>
  <div>
    <div class="row m-md">
      <div class="col-md-2 strong">Purge cache for uri:</div>
      <div class="col-md-10">
        <input type="text" name="" id="" class="col-md-8" :placeholder="site.url + '/'" v-model="purgeUri">
        <button class="btn btn-sm btn-primary m-l-sm" @click="purgeCache">Purge</button>
      </div>
    </div>
    <div class="row m-md">
      <div class="col-md-2 strong">Purge entire page cache (ban):</div>
      <div class="col-md-10"><button class="btn btn-med btn-primary" @click="banCache">Ban Cache</button></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      purgeUri: null
    }
  },
  name: 'Tools',
  props: ['site'],
  methods: {
    purgeCache () {
      axios.post('/am/site/' + this.site.url + '/cache/purge', {
        uri: this.purgeUri
      })
        .then(r => {
          this.$toastr.success(r.data.msg, 'Purge successfull!')
          this.purgeUri = ''
        })
        .catch(e => {
          this.$toastr.error(e, 'Purge failed!')
        })
    },
    banCache () {
      axios.post('/am/site/' + this.site.url + '/cache/ban')
        .then(r => {
          this.$toastr.success(r.data.msg, 'Ban good!')
        })
        .catch(e => {
          this.$toastr.error(e, 'Purge failed!')
        })
    }
  }
}
</script>
<style scoped>
.strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Site/Tools.vue